// extracted by mini-css-extract-plugin
export default {"ToolBar":"suit-detail_ToolBar__j6CN-","Table":"suit-detail_Table__IxjYo"};